import { render, staticRenderFns } from "./DisplayStandardizedMindMap.vue?vue&type=template&id=1e7743a2&"
import script from "./DisplayStandardizedMindMap.vue?vue&type=script&lang=ts&"
export * from "./DisplayStandardizedMindMap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DisplayStandardizedMindMap.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
